import React, { useEffect } from 'react';
import { App, notification } from 'antd';
import RouteView from './route';
import zhCN from 'antd/locale/zh_CN';
import { ConfigProvider } from 'antd';
import { setSiteInfo } from './store/modules/site-info';
import { useDispatch } from 'react-redux';
import { sys } from './service';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import './App.scss'

dayjs.locale('zh-cn');

const AppView = () => {
    const dispatch = useDispatch()

    useEffect(() => {
        // 系统配置1
        sys.getConfig().then(({ data }) => {
            dispatch(setSiteInfo({ ...data }))
        }).catch(error => {
            notification({
                type: 'error',
                content: error.message
            })
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <ConfigProvider
            locale={zhCN}
            theme={{
                token: {
                    colorPrimary: '#44afad',
                },
            }}
        >
            <App>
                <RouteView />
            </App>
        </ConfigProvider>
    )
}

export default AppView;
